var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"register"},[_c('section',{staticClass:"section"},[_c('Breadcrumb',{attrs:{"step":"1"}})],1),_c('section',{staticClass:"wrapper section"},[_c('FormRegister')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }